@if (isLayersGroup) {
  <ul class="list-inline">
    @if (visibleItem['Trails']) {
      <li>
        <svg-icon
          class="fuel-icon"
          src="/assets/icons/map-icons/shared/trails.svg"
          svgAriaLabel="Trails"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Heatmap']) {
      <li>
        @if ($isSnow()) {
          @if ($isSatellite()) {
            <img
              alt="Map type is Snow type with satellite view."
              aria-label="Snow Satellite Ride Heatmap"
              ngSrc="/assets/icons/open-ride-area-snow-sm-sat.svg"
              i18n-alt
              i18n-aria-label
            />
          } @else {
            <img
              alt="Map type is Snow style with a regular map view."
              aria-label="Snow Map Ride Heatmap"
              ngSrc="/assets/icons/open-ride-area-snow-sm.svg"
              i18n-alt
              i18n-aria-label
            />
          }
        } @else {
          @if ($isSatellite()) {
            <img
              alt="Map type is Off-Road style with satellite view."
              aria-label="Offroad Satellite Ride Heatmap"
              ngSrc="/assets/icons/open-ride-area-off-road-sm-sat.svg"
              i18n-alt
              i18n-aria-label
            />
          } @else {
            <img
              alt="Map type is Off-Road style with a regular map view."
              aria-label="offroad Map Satellite Ride Heatmap"
              ngSrc="/assets/icons/open-ride-area-off-road-sm.svg"
              i18n-alt
              i18n-aria-label
            />
          }
        }
      </li>
    }
    @if (visibleItem['TrailDifficulty']) {
      <li>
        <svg-icon
          class="fuel-icon"
          src="/assets/icons/trail-difficulty.svg"
          svgAriaLabel="Trail Difficulty"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Fuel']) {
      <li>
        <svg-icon
          class="fuel-icon"
          src="/assets/icons/map-icons/shared/poi-fuel.svg"
          svgAriaLabel="Fuel"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Lodging']) {
      <li>
        <svg-icon
          class="lodging-icon"
          src="/assets/icons/map-icons/shared/poi-lodging.svg"
          svgAriaLabel="Lodging"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Unknown']) {
      <li>
        <svg-icon
          class="unknown-icon"
          src="/assets/icons/map-icons/shared/poi-other.svg"
          svgAriaLabel="Unknown"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['PlannedRides']) {
      <li>
        <svg-icon
          class="planned-ride-icon"
          src="/assets/icons/map-icons/shared/planned-ride.svg"
          svgAriaLabel="Route"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['TrackedRides']) {
      <li>
        <svg-icon
          class="tracked-ride-icon"
          src="/assets/icons/map-icons/shared/tracked-ride.svg"
          svgAriaLabel="Ride"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['InProgressRide']) {
      <li>
        <svg-icon
          class="tracked-ride-icon"
          src="/assets/icons/map-icons/shared/tracked-ride.svg"
          svgAriaLabel="InProgress Ride"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Waypoint']) {
      <li>
        <svg-icon
          class="waypoint-icon"
          src="/assets/icons/map-icons/shared/waypoint.svg"
          svgAriaLabel="Waypoint"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Dealer']) {
      <li>
        @if (brand === 'indian') {
          <svg-icon
            class="dealer-icon"
            src="/assets/icons/map-icons/indian/poi-dealer.svg"
            svgAriaLabel="Dealer"
            i18n-svgAriaLabel
          />
        }
        @if (brand === 'offroad') {
          <svg-icon
            class="dealer-icon"
            src="/assets/icons/map-icons/offroad/poi-dealer.svg"
            svgAriaLabel="Dealer"
            i18n-svgAriaLabel
          />
        }
        @if (brand === 'slingshot') {
          <svg-icon
            class="dealer-icon"
            src="/assets/icons/map-icons/slingshot/poi-dealer.svg"
            svgAriaLabel="Dealer"
            i18n-svgAriaLabel
          />
        }
      </li>
    }
    @if (visibleItem['Adventure']) {
      <li>
        @if (brand === 'indian') {
          <svg-icon src="/assets/icons/map-icons/indian/adventures.svg" svgAriaLabel="Adventures" i18n-svgAriaLabel />
        }
        @if (brand === 'offroad') {
          <svg-icon src="/assets/icons/map-icons/offroad/adventures.svg" svgAriaLabel="Adventures" i18n-svgAriaLabel />
        }
        @if (brand === 'slingshot') {
          <svg-icon
            src="/assets/icons/map-icons/slingshot/adventures.svg"
            svgAriaLabel="Adventures"
            i18n-svgAriaLabel
          />
        }
      </li>
    }
    @if (visibleItem['Radar']) {
      <li>
        <svg-icon class="radar-icon" src="/assets/icons/radar.svg" svgAriaLabel="Radar" i18n-svgAriaLabel />
      </li>
    }
    @if (visibleItem['Land']) {
      <li>
        <svg-icon class="land-icon" src="/assets/icons/info-filled.svg" svgAriaLabel="Land" i18n-svgAriaLabel />
      </li>
    }
    @if (visibleItem['Satellite']) {
      <li>
        <svg-icon
          class="satellite-icon"
          src="/assets/icons/map-icons/shared/satellite.svg"
          svgAriaLabel="Satellite"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['SnowDepth']) {
      <li>
        <svg-icon
          class="snow-depth-icon"
          src="/assets/icons/snow-depth.svg"
          svgAriaLabel="Snow Depth"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['RideConditions']) {
      <li>
        <svg-icon
          class="ride-conditions-icon"
          src="/assets/icons/condition.svg"
          svgAriaLabel="Snow Conditions"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Conditions']) {
      <li>
        @if ($isSnow()) {
          <svg-icon
            class="ride-conditions-icon"
            src="/assets/icons/condition.svg"
            svgAriaLabel="Snow Conditions"
            i18n-svgAriaLabel
          />
        } @else {
          <svg-icon
            class="ride-conditions-icon"
            src="/assets/icons/alert-triangle.svg"
            svgAriaLabel="Trail Conditions"
            i18n-svgAriaLabel
          />
        }
      </li>
    }
    @if (visibleItem['Areas']) {
      <li>
        <svg-icon
          class="geofence-icon"
          src="/assets/icons/map-icons/shared/geofence.svg"
          svgAriaLabel="Areas"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Food']) {
      <li>
        <svg-icon
          class="food-icon"
          src="/assets/icons/map-icons/shared/poi-food.svg"
          svgAriaLabel="Food"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['Gas']) {
      <li>
        <svg-icon
          class="gas-icon"
          src="/assets/icons/map-icons/shared/poi-waypoint-gas.svg"
          svgAriaLabel="Fuel"
          i18n-svgAriaLabel
        />
      </li>
    }
    @if (visibleItem['CloudCover']) {
      <li>
        <svg-icon class="cloud-cover-icon" src="/assets/icons/cloud.svg" svgAriaLabel="Cloud Cover" i18n-svgAriaLabel />
      </li>
    }
    @if (selectedItems.length > limit) {
      <li>
        <span> +{{ selectedItems.length - limit }} </span>
      </li>
    }
    <ng-content select="li" />
  </ul>
}
